export const splitEveryNCharacters = (target, n) => target.match(new RegExp(`.{1,${n}}`, 'g'));
